export default "__VITE_ASSET__0c0a68c0__"